import { render, staticRenderFns } from "./surveyList.vue?vue&type=template&id=c76c5b96&scoped=true&"
import script from "./surveyList.vue?vue&type=script&lang=js&"
export * from "./surveyList.vue?vue&type=script&lang=js&"
import style0 from "./surveyList.vue?vue&type=style&index=0&id=c76c5b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76c5b96",
  null
  
)

export default component.exports